import { StyleSheet } from "@react-pdf/renderer";

export const commonStyles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "Montserrat",
    backgroundColor: "#ffffff",
  },
  header: {
    marginBottom: 15,
    backgroundColor: "#f3f4f6",
    padding: 8,
    borderRadius: 6,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
  },
  divider: {
    height: "100%",
    width: 1,
    backgroundColor: "#e2e8f0",
  },
  headerTop: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: 10,
  },
  headerBottom: {
    display: "flex",
    alignItems: "center",
  },
  imageContainer: {
    marginBottom: 15,
    alignItems: "center",
  },
  image: {
    width: "80%",
    height: 200,
    objectFit: "cover",
    borderRadius: 8,
  },
  logo: {
    width: "64px",
    height: "64px",
    marginBottom: 15,
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#1f2937",
    marginTop: 8,
    marginBottom: 4,
  },
  sectionContent: {
    fontSize: 9,
    color: "#374151",
    lineHeight: 1.4,
  },
});
